"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketEntryHistoryList = void 0;
const TimeUtil_1 = require("../../utils/TimeUtil");
class TicketEntryHistoryList extends Array {
    constructor() {
        super(...arguments);
        this.getEnteredTimeConverted = (withoutPattern) => {
            const ticketEntryHistoryList = new TicketEntryHistoryList();
            if (this.length > 0) {
                this.forEach(x => {
                    x.barcodeDisplayValue = x.ticket.gameNumber;
                    if (x.enteredTime) {
                        x.enteredDateConverted = (0, TimeUtil_1.zonedDateTimeFor)(x.enteredTime).format('MMM Do, YYYY');
                        x.enteredTimeConverted = (0, TimeUtil_1.zonedDateTimeFor)(x.enteredTime).format('hh:mm a');
                    }
                    if (x.ticket.bookNumber) {
                        x.barcodeDisplayValue += `-${x.ticket.bookNumber}`;
                    }
                    if (x.ticket.ticketNumber) {
                        x.barcodeDisplayValue += `-${x.ticket.ticketNumber}`;
                    }
                    if (x.ticket.validationCode) {
                        x.barcodeDisplayValue += `-${x.ticket.validationCode}`;
                    }
                    else if (x.ticket.entryCode) {
                        const pattern = x.ticket.entryCode.length === 30
                            ? '######-#####-#####-#####-#####-####'
                            : '#####-#####-#####-#####-#####';
                        const entryCode = !!x.ticket.entryCode ? x.ticket.entryCode : '';
                        let i = 0;
                        x.barcodeDisplayValue = withoutPattern
                            ? entryCode
                            : pattern.replace(/#/g, () => entryCode[i++]);
                    }
                    else if (x.ticket.transactionId) {
                        x.barcodeDisplayValue = x.ticket.transactionId;
                        x.isOnlineEntry = true;
                    }
                    x.prizes.sort((a, b) => {
                        if (a.prizeType < b.prizeType) {
                            return -1;
                        }
                        if (a.prizeType > b.prizeType) {
                            return 1;
                        }
                        return 0;
                    });
                    ticketEntryHistoryList.push(x);
                });
            }
            return ticketEntryHistoryList;
        };
    }
}
exports.TicketEntryHistoryList = TicketEntryHistoryList;
//# sourceMappingURL=TicketEntryHistoryList.js.map